<template>
<v-overlay :value="loading" v-if="loading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
<feature-card v-else-if="host" :host="host"></feature-card>
  <v-sheet color="transparant" v-else>
     <div style="position:absolute;top:0;right:0;z-index:1000" >
      <v-btn v-if="!user && !showLogin" dark text  to="/login"><v-icon left>person</v-icon>inloggen</v-btn>
        <v-btn v-else-if="!user" dark text  @click="showLogin=!showLogin"><v-icon left>search</v-icon>Zoeken</v-btn>
    
    </div>
    <v-img
      dark
      :src="banner"
      class="white--text align-center text-center pb-15"
      height="70vh"
      
    >
    <eetplein street="eetplein" :city="title" class="large" style="margin-top:30vh;" @click="showAll=!showAll"></eetplein>
    
    <!--eetplein class="mx-auto mb-10"
          street="mijn eetplein"
          :city="title"
          :elevation="0"
        >
        </eetplein-->
        <v-card class="rounded-xl mx-auto mt-15" flat 
      :style="`margin-bottom:${showAll ? 150 : 75}px;max-width:${$config.page.width}px;`" :dark="false" light>
        <v-expand-transition v-if="showLogin">
          <phone-validator  ref="phonecheck" class="mx-auto"
          @blur="showLogin=false" v-model="phone" dense
          @valid="goToDashboard" hint="Vul je mobiele nummer in om door te gaan"
          @reset="resetState"></phone-validator>
          </v-expand-transition>
          
        <v-card-title v-else-if="!address" class="pl-5 pt-3 pb-2 primary--text font-weight-light" :class="{'pb-3': $vuetify.breakpoint.mobile}"
          >
         
          <!--address-select-name v-if="!address" style="width:100%" v-model="address" show-current icon="search" @search="setSearch" ></address-select-name-->
        <listings
          type="search"
          ref="listings"
          :manual="true"
         :height="55"
         icon="search"
         color="transparent" class="mt-2 mb-2"
          show
           placeholder="Zoek een eetplein of je adres"
          :autofocus="true"
          v-model="newAddress"
          @search="setSearch"
         @select="setAddress"
          @cancel="address = null;newAddress=null"
          :show-current="true"
        >

        </listings>


        
          </v-card-title>
          
        <v-card-title v-else class="pl-7 py-5 primary--text font-weight-light"
          ><v-icon left color="primary">pin_drop</v-icon>{{ address.name }}
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="address=null"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <center v-if="!showAll && !address"><v-btn elevation="2" large rounded class="mt-2 mb-5" @click="showAll=true" color="primary"><v-icon class="mr-2">manage_search</v-icon>Zoek op eetplein (dorp/stad)</v-btn></center>
          </v-card>
    </v-img>
    
          <v-sheet class="main-content mt-10">
             <template v-if="showAll">
             <v-card-title class="font-weight-light text-h4" v-if="hub" color="primary"  @click="prevHub">
               <v-btn icon><v-icon large>arrow_back</v-icon></v-btn>{{hub.name}}
               </v-card-title> 
            <!--v-card-title class="font-weight-light text-h4" @click="reset" v-else-if="parent" color="primary"><v-btn icon  large ><v-icon>arrow_back</v-icon></v-btn>{{parent.name}}
              </v-card-title-->
            <v-card-title class="font-weight-light text-h4" v-else-if="search" color="primary">Resultaten voor: {{search}}</v-card-title> 
            <!--v-card-title class="font-weight-light text-h4" v-else-if="address" color="primary">{{address.name}}</v-card-title--> 
            <v-card-title class="font-weight-light text-h4" v-else-if="!address" color="primary"> Of selecteer via eetplein (woonplaats)</v-card-title> 
             </template>
            <template>
           
          <v-chip-group v-model="menuFilter" column 
             active-class="primary font-weight-bold" class="ml-5"
            >
            <!--v-chip label v-if="parent && !address" color="primary" @click="reset">{{parent.name}}<v-icon right>close</v-icon></v-chip-->
              <v-chip outlined v-if="menuFilter && menus.length>0"
              :value="null">Alle</v-chip>
              <v-chip v-for="menu in menus"
              :outlined="menu!=menuFilter" 
              :value="menu" :key="menu"><template v-if="$config.menu[menu]">{{$config.menu[menu].title}}</template></v-chip>
            </v-chip-group>
         
            </template>
            <v-divider></v-divider>
        <v-container class="px-3" no-gutters v-if="address || showAll">
          <transition-group tag="div" name="slide" class="row">
            
            <v-col
              v-for="(item, i) in hublist.filter(h=>h._id.includes('organisation'))"
              cols="12"
              md="6"
              lg="4"
              xl="4"
              :key="'host' + i"
            >
              <organisation-card 
                v-if="item._id.includes('organisation')"
                class="gallery-card rounded-lg"
                :value="item"
                @select="orderHost"
                :address="address"
                flat
                outlined :show-city="hub && item._address && item._address.city!==hub.name ? true : false"
              >
              <template v-slot:actions="{ allow }">
                 <v-card-actions>
                <v-btn text class="px-5" @click.stop="showHost(item)" color="grey">Informatie</v-btn>
                <v-spacer></v-spacer>
                <v-btn :disabled="!allow" dark class="px-5" color="primary" @click.stop="orderHost(item)">Bestellen</v-btn>
                 </v-card-actions>
              </template>
              </organisation-card>
            </v-col>
            <v-col
              v-for="(item, i) in hublist.filter(h=>h._id.includes('hub'))"
              cols="12"
              md="6"
              lg="4"
              xl="4"
              :key="'hub' + i"
            >
              <hub-card elevation="0"
                v-if="item._id.includes('hub')"
                class="gallery-card rounded-xl"
                :value="item"
                flat
                
                @select="showHub"
              ></hub-card>
            </v-col>
          </transition-group>
        
        </v-container>
        <v-divider v-if="showAll" class="mt-5"></v-divider>
        </v-sheet>



    <v-sheet>
      
      <v-container
        :style="`max-width:${$config.page.width}px`"
        class="mx-auto pb-15" :class="{'pt-10': showAll}"
      >
        <v-row>
          <v-col cols="12" class="text-center">
           
            <v-card-title class="px-0 font-weight-light text-h4 justify-center"
              >Vind je favoriete lokale restaurant</v-card-title
            >
            <v-card-text class="pa-0 mt-0 text-body-1"
              >Iedereen heeft wel zijn vaste pizzeria, chinees, friet- of
              shoarmatent. En vaak heb je ook al bepaald wat je het lekkerst
              vindt en dus het vaakst neemt. Eetplein.nl brengt deze zaken samen
              in 1 app, je eigen eetplein!
              <br />
              
             
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
<v-sheet color="primary" dark>
      <v-container
        :style="`max-width:${$config.page.width}px`"
        class="mx-auto py-10"
      >
         <v-row>
             <v-col
            cols="12"
            md="6"
            :order="$vuetify.breakpoint.mobile ? 'last' : null"
          >
           <v-card-title class="px-0 font-weight-light text-h4"
              >Actiecode</v-card-title
            >
          
          <div center class="px-auto mt-10"> 
            <v-lazy
       
        :options="{
          threshold: .5
        }"
        min-height="100"
        transition="fade-transition"
      >
            <collect-code :value="code" :size="5" dark show @success="saveCode" text="Klik hier" color="primary">
            <template v-slot:success="{ host }">
                <v-btn dark large :to="host._id" v-if="host._id != 'organisation/bestelinfo'" class="float-right">Bestellen</v-btn>
            </template>
            </collect-code>
            </v-lazy>
          </div>
             <!--v-otp-input
              v-model="code"
              :disabled="loading"
              @finish="saveCode(code)"
            ></v-otp-input-->
          </v-col>
          <v-col
            cols="12"
            md="6"
            :order="$vuetify.breakpoint.mobile ? 'first' : null"
          >
            <v-card-title class="px-0 font-weight-light text-h4"
              >Stempelen maar</v-card-title
            >
            <v-card-text class="pa-0 my-3 text-body-1"
              >Op het eetplein kan je stempels sparen bij elke bestelling. Na 10
              keer bestellen kan je deze inleveren voor extra eten of
              bijvoorbeeld een drankje.<br><br>
              
              Heb je een code ontvangen van een van onze restaurants dan kun je deze hier invoeren en begin met bestellen. <br />
              
              </v-card-text>
          </v-col>
        
        </v-row>
      </v-container>
    </v-sheet>
    <v-sheet color="grey lighten-4">
      <v-container
        :style="`max-width:${$config.page.width}px`"
        class="mx-auto py-10"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
            :order="$vuetify.breakpoint.mobile ? 'first' : null"
          >
            <v-card-title class="px-0 font-weight-light text-h4"
              >Je eigen eetplein app</v-card-title
            >
            <v-card-text class="pa-0 my-3 text-body-1"
              >Al je favoriete eetzaken op 1 plek. Niet meer scrollen door eten
              wat je niet wilt of zaken waar je nooit besteld. Geen 5 of meer
              verschillende apps maar alles op 1 plek en op dezelfde manier
              bestellen in onze eigen app. <br />
              
              <v-store class="mx-auto rounded-xl pa-5 px-3 mx-3" flat color="transparent" :max-width="400" :show="true"></v-store>
              </v-card-text>
          </v-col>
          <v-col
            cols="12"
            md="6"
            :order="$vuetify.breakpoint.mobile ? 'last' : null"
          >
            <v-img src="/img/screen1.png" width="50%" class="mx-auto"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-sheet>
      <v-container
        :style="`max-width:${$config.page.width}px`"
        class="mx-auto py-10"
      >
        <v-row>
          <v-col class="text-center">
            <v-card-title class="px-0 font-weight-light text-h4 justify-center"
              >Wist je dat?</v-card-title
            >
            <v-card-text class="pa-0 mt-3 text-body-1"
              >Elke keer als je een bestelling doet via <b>thuisbezorgd.nl</b>,
              de ondernemer meer dan <b>14%</b> van deze omzet moet afdragen aan
              die bestelgigant? Veel hè! Dat vonden wij ook en daarom betaalt de
              ondernemer bij ons alleen maar een abonnement, ongeacht hoeveel
              van zijn klanten bestellen. Gebruik daarom nu eetplein.nl. Zo maak
              je het je zelf niet alleen makkelijk, maar help je ook de
              ondernemer. Echt een win-win!</v-card-text
            >
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-sheet color="#E3F8FF">
      <v-container
        :style="`max-width:${$config.page.width}px`"
        class="mx-auto py-10"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
            :order="$vuetify.breakpoint.mobile ? 'first' : null"
          >
            <v-card-title class="px-0 font-weight-light text-h4"
              >Pizza met wat?!</v-card-title
            >
            <v-card-text class="pa-0 mt-3 text-body-1"
              >Je vindt je pizza net even iets lekkerder met extra kaas of je
              wilt nu eenmaal graag de ene helft met champignons en de andere
              helft met salami. Via eetplein.nl hoef je dit maar 1 keer zelf in
              te voeren. Daarna wordt jouw voorkeur automatisch bewaard.
              Razendsnel en foutloos herhaalbestellen dus!
              <br />
              <v-btn
                color="primary"
                class="mt-5"
                @click="$vuetify.goTo(target, { duration: 500, offset: 120 })"
                >Eten bestellen</v-btn
              >
            </v-card-text>
          </v-col>
          <v-col
            cols="12"
            md="6"
            :order="$vuetify.breakpoint.mobile ? 'last' : null"
          >
            <v-img
              src="/img/pizza1.jpeg"
              max-width="800"
              max-height="400"
            ></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-sheet color="primary" dark>
      <v-container
        :style="`max-width:${$config.website_width}px`"
        class="mx-auto py-10 pb-15"
      >
          <v-row>
         
          <v-col
            cols="12"
            md="6"
            :order="$vuetify.breakpoint.mobile ? 'last' : null"
          >
            <v-img
              src="/img/printapp.png"
              max-width="800"
              max-height="400"
            ></v-img>
          </v-col>
           <v-col
            cols="12"
            md="6"
            :order="$vuetify.breakpoint.mobile ? 'first' : null"
          >
            <v-card-title class="px-0 font-weight-light text-h4"
              >Bonprinter app voor Ondernemers </v-card-title
            >
            <v-card-text class="pa-0 mt-3 text-body-1"
              >Download de printer app en koppel gelijk uw (bon)printer aan Eetplein.
              <br /><br />
               <v-img
                  src="/img/windows-badge.png" style="cursor:pointer"
                  max-width="200"
                  max-height="100"  v-on:click="goToStore"
                ></v-img>
              </v-card-text>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  
  
    <v-footer dark :fixed="hub ? true : false" class="justify-center pa-0">
      <v-divider
        style="flex: 0 0 100%"
        v-if="$vuetify.breakpoint.mobile"
      ></v-divider>

      <v-btn text href="https://mijn.eetplein.nl/login" class="caption"
        >Ondernemer</v-btn
      >|<v-btn text to="/login" class="caption">Login met mobiel</v-btn>|
      <v-btn
        src="https://docs.google.com/document/d/e/2PACX-1vQm8SnrOuL8TQM_AWltj5jIbN91InD1J3m8HN6MFJR7zCt3eVgTVO72iaWU-3oxQDoDAAtL-BTSfG7A/pub"
        target="_new"
        class="caption" text
        >privacy</v-btn
      >
      |
      <v-btn class="caption"
        ><a href="mailto:info@eetplein.nl" class="white--text"
          >contact</a
        ></v-btn
      >
    </v-footer>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageHeader from "../components/PageHeader.vue";
import HubCard from "../components/HubCard.vue";
import OrganisationCard from "../components/OrganisationCard.vue";
//import AddressSelectName from "../components/AddressSelectName.vue";
import Listings from "../components/address/Listings.vue";
import Eetplein from "@/components/Eetplein";
import vStore from "@/components/feature/vStore.vue";
import phoneValidator from "../components/phoneValidator.vue";
import CollectCode from "../components/CollectCode.vue";
import featureCard from '../components/feature/featureCard.vue'

export default {
  components: {
    PageHeader,
    HubCard,
    OrganisationCard,
    CollectCode,
    Eetplein,
    vStore,
    Listings,
    phoneValidator,
    featureCard
  },
  data() {
    return {
      loading: true,
      list: [],
      search: null,
      menuFilter: null,
      phone: null,
      showLogin: false,
      newAddress: null,
      listings: [],
      path: [],
      showAll: true//this.$vuetify.breakpoint.mobile
    };
  },
  computed: {
    ...mapGetters(["hub", "host","user","code"]),
    target() {
      return 0;//document.body.scrollHeight;
    },
    banner(){
      //return '/banner/friends.jpg'
      return '/banner/bg_login-min.jpg'
    },
    hublist(){
      let list = this.list.filter(host=>!this.menuFilter || (host.type && host.type.includes(this.menuFilter))).sort(compare)
      
      if (this.search) {
          return list.filter(
          (hub) =>
            hub.name.toLowerCase().includes(this.search.toLowerCase())
        )
      }
      if (this.hub)  {
        return list.filter((hub) => hub._parents.includes(this.hub._id))
      }

      if (this.address && this.address.zipcode){
        let zip = this.address.zipcode.substring(0,4)
        return list.filter(hub=>
        (hub.region && hub.region.includes(zip)) 
        || (hub.regions && hub.regions.map(r=>r.zipcode).includes(zip))
        || (hub.regions && hub.regions.map(r=>r.city).includes(this.address.city))
        )
       }
       console.log( this.search,this.hub, this.address)
      return list.filter((hub) => hub.main)
    },
    hublistss() {
      //
      let list = this.list.filter((hub) => hub.main);
       if (this.search && !this.hub && !this.hub) {
        return this.list.filter(
          (hub) =>
            (hub.name.toLowerCase().includes(this.search.toLowerCase()) &&
              (hub._subs.length == 0 || !this.parent)) ||
            (this.parent &&
              hub._parent &&
              hub._parent.name.toLowerCase().includes(this.search.toLowerCase()))
        );
        
      }
      if (this.hub) {
        list = this.hub._subs || [];
      } else if (this.parent) {
        list = this.parent._subs;
     } else  if (this.address && this.address.zipcode){
        let hosts = [], hubs = [], zip = this.address.zipcode.substring(0,4)
        this.list.filter(hub=>hub.region && hub.region.includes(zip)).map(hub=> hubs.push(hub))
        if (hubs.length==0) this.list.map(hub=>{
        if (hub._subs) hub._subs.map(host=>{
            if (host.regions && host.regions.map(r=>r.zipcode ? r.zipcode.replace('#','') : r.city).includes(zip)
            && hosts.filter(h=>h._id==host._id).length==0
            ) {
              if (hubs.filter(h=>h._id==hub._id).length==0) hubs.push(hub)
              hosts.push(host)
            }
          })
          
        })
        if (hubs.length==1){
          this.setHub(hubs[0])
          if (this.hub && this.hub._parent) this.parent = this.hub._parent
          return this.hub._subs
        }
        list = hubs.concat(hosts)
      }
      return list.filter(host=>!this.menuFilter || (host.type && host.type.includes(this.menuFilter))).map(h=>{
        h.open = h.timetable ? this.isOpen(h.timetable) : false
        return h
      }).sort(compare)
    },
    menus(){
      if (!this.hublist) return []
      let menus = []
      this.hublist.map(host=>{
        if (host.type) host.type.map(type=>{
          if (!menus.includes(type)) menus.push(type)
        })
      })
      return menus
    },
    title() {
      if (this.hub) return this.hub.name
      return "lekker lokaal bestellen";
    },
    address: {
      get() {
        return this.$store.state.config.address || null;
      },
      set(value) {
        this.setConfig({ address: value });
      },
    },
    code: {
      get() {
        return this.$store.state.code;
      },
      set(value) {
        this.setCode(value.toUpperCase());
      },
    },
  },
  async mounted() {
    if (!this.feauture ) await this.init()
  },
  watch: {
    address(value){
      this.reset()
    },
    showAll(value){
      this.setHub(null)
    }
  },
  methods: {
    ...mapActions(["setConfig", "setHub","setHost","resetState","setCode", "logout"]),
    async init(){
      this.setHost()
      let response = await this.$http.get("/api/hub/search/list", {});
      if (!response.data || !response.data.map) return this.handleLogout()
      this.list = response.data.map(h=>{
        h.open = h.timetable ? this.isOpen(h.timetable) : false
        return h
      }).sort(compare);
      this.loading = false;
    },
    reset(){
      this.search = null
      this.setHub(null);
      this.path =[]
    },
    setSearch(search){
      this.search = search
    },
    setResult(list) {
      this.listings = list;
    },
    setAddress(address) {
      this.address = address;
    },
     isOpen (timetable,date){
       if (!timetable) return false
      if (!date) date = new Date()
      timetable = timetable.filter(t=>t.day==this.$moment(date).format('dddd'))
      if (!timetable || timetable.length==0) return false
      var format = 'hh:mm'
      var time = this.$moment(date, format),
      beforeTime = this.$moment(timetable[0].start, format),
      afterTime = this.$moment(timetable[0].end, format);
      if (afterTime.isBefore(beforeTime)) afterTime.add(1, 'days')
      return time.isBetween(beforeTime, afterTime)
    },
    showHub(hub) {
      if (!hub) return this.reset()
      this.search = null
      hub = this.list.filter((h) => h._id == hub._id)[0];
      this.path.push(hub._id)
      this.setHub(hub);
      //this.$vuetify.goTo(this.target, { duration: 500, offset: 120 });
      //this.$router.push({name: 'dashboard'})
    },
    prevHub(){
      if (this.path.length==0) return this.showHub(null)
      this.path = this.path.slice(0, this.path.length-1) 
      if (!this.path || this.path.length==0) return this.showHub(null)
      let hub = this.list.filter((h) => h._id == this.path[this.path.length-1])[0];
      this.setHub(hub);
    },
    orderHost(host) {
      this.setHost(host)
      //if (host.url) return window.location = "https://" + host.url + '/' + host._id
      this.$router.push({ path: "/" + host._id  });
    },
    showHost(host) {
      this.setHost(host)
      //if (host.url) return window.location = "https://" + host.url
      this.$router.push({ path: "/" + host._id + "/info" });
    },
    goToStore(){
      window.open('https://www.microsoft.com/nl-nl/p/eetplein/9mwjck40vmpm')
    },
    goToDashboard(){
      if (!this.user) return false
      this.$router.push({ path: "/dashboard" });
    },
    saveCode(code){
      this.setCode(code)
    },
     handleLogout(){
      this.logout()
      //this.$router.push('/')
    },
  },
};
function compare(a, b) {
  if (a.open && !b.open) {
    return -1;
  } else {
    return 1;
  }
  // a must be equal to b
  return 0;
}
</script>

<style>
.manual-v-layout {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  padding-bottom: 8px !important;
  padding-top: 8px !important;
}
.gallery-card {
  transform-origin: center center 0;
  transition: 0.8s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.fade-transition-leave,
.fade-transition-leave-active,
.fade-transition-leave-to {
  display: none;
}
.slide-enter {
    opacity: 0;
    /*transform: translateX(500px);*/
    height: 0px;
}

.slide-enter-active {
    transition: all 0.7s ease-out;
}

.slide-enter-to {
   opacity: 1;
    transform: translateY(0px);
    height: auto;
}

.slide-leave {
    transform: translateX(0px);
}

.slide-leave-active {
    transition: all 0.7s ease-out;
    position: absolute;
}

.slide-leave-to {
    transform: translateY(2000px);
     opacity: 0;
}

.slide-move {
  transition: all 1s;
}
</style>